export default "__VITE_ASSET__CyPXwYyR__"